/**
 * 审核管理 API 服务
 */
import { api, API_PATHS, PaginatedData } from './client';
import type { AppRequestData } from './apps';

// 列表查询参数
export interface ListReviewsParams {
  page?: number;
  pageSize?: number;
  status?: string;
  type?: string;
  [key: string]: string | number | boolean | undefined;
}

// 审核请求
export interface ReviewRequest {
  note?: string;
}

/**
 * 获取审核请求列表
 */
export async function getReviews(params?: ListReviewsParams): Promise<PaginatedData<AppRequestData>> {
  return api.get<PaginatedData<AppRequestData>>(API_PATHS.REVIEWS, params);
}

/**
 * 获取审核请求详情
 */
export async function getReview(id: string): Promise<AppRequestData> {
  return api.get<AppRequestData>(`${API_PATHS.REVIEWS}/${id}`);
}

/**
 * 批准审核请求
 */
export async function approveReview(id: string, data?: ReviewRequest): Promise<void> {
  await api.post<null>(`${API_PATHS.REVIEWS}/${id}/approve`, data);
}

/**
 * 拒绝审核请求
 */
export async function rejectReview(id: string, data?: ReviewRequest): Promise<void> {
  await api.post<null>(`${API_PATHS.REVIEWS}/${id}/reject`, data);
}
